var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetirementSystem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.791,
    height: 30.393,
    viewBox: "0 0 19.791 30.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "elderly_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M14.827,33.393l-1.7-1.272,3.675-4.912-.283-6.75a23.081,23.081,0,0,1,.194-3.87A16.936,16.936,0,0,1,17.548,13L14.12,14.98V18.9H12v-5.16l5.9-3.393a5.792,5.792,0,0,1,1.149-.53,3.4,3.4,0,0,1,1.043-.177,2.393,2.393,0,0,1,1.714.742,7.591,7.591,0,0,1,1.467,2.332,6.566,6.566,0,0,0,2.085,2.668,10.683,10.683,0,0,0,3.322,1.643,1.771,1.771,0,0,1,.477-.194,2.115,2.115,0,0,1,.477-.053,2.086,2.086,0,0,1,1.484.654,2,2,0,0,1,.671,1.467v14.49H30.73V18.9a1.06,1.06,0,0,0-2.12,0v1.06H27.55V18.8a10.115,10.115,0,0,1-3.092-1.484,8.619,8.619,0,0,1-2.527-2.58,15.04,15.04,0,0,0-.654,2.651,11.9,11.9,0,0,0-.159,2.58l3.428,4.842v8.588h-2.12v-7.74l-3-3.357-.353,5.442Zm7.7-25.233a2.483,2.483,0,0,1-1.82-.76,2.483,2.483,0,0,1-.76-1.82,2.483,2.483,0,0,1,.76-1.82,2.56,2.56,0,0,1,3.64,0,2.483,2.483,0,0,1,.76,1.82,2.483,2.483,0,0,1-.76,1.82,2.483,2.483,0,0,1-1.82.76Z",
    transform: "translate(-12 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirementSystem);
export default __webpack_public_path__ + "static/media/retirement-system.e249b31449845d3308a90db81073a83a.svg";
export { ForwardRef as ReactComponent };